import useAppStore from "store/app"

const useInput = (fieldName, validate) => {
  const { input_value, error_message, touched } = useAppStore((state) => state.fields[fieldName])

  const updateFieldInputValue = useAppStore((state) => state.updateFieldInputValue)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)
  const updateFieldTouched = useAppStore((state) => state.updateFieldTouched)

  const handleChange = (e) => {
    const { value } = e.target

    updateFieldInputValue(fieldName, value)

    if (!touched) return

    const errorMessage = validate(value)

    updateFieldErrorMessage(fieldName, errorMessage)
  }

  const handleBlur = (e) => {
    if (touched) return

    updateFieldTouched(fieldName, true)

    const { value } = e.target

    const errorMessage = validate(value)

    updateFieldErrorMessage(fieldName, errorMessage)
  }

  return {
    handleChange,
    inputValue: input_value,
    errorMessage: error_message,
    handleBlur,
    touched,
    updateFieldInputValue,
  }
}

export default useInput
